/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState } from "react";

import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";

import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import GridTextfield from "../../widgets/GridTextfield";
import GridDropdown from "../../widgets/GridDropdown";

import { reNumbers, reEmail, alphanum } from "../../../utils/fieldValidator.js";

import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

let depFullNameError = "";
let depGenderError = "";
let depRaceError = "";
let depIdTypeError = "";
let depIdNumberError = "";
let depRelationshipError = "";
let depYearsToSupportError = "";

const raceData = [
  { key: "CHI", value: "Chinese" },
  { key: "IND", value: "Indian" },
  { key: "MAL", value: "Malay" },
  { key: "OTH", value: "Others" },
];

const identityTypeData = [
  { key: "NRIC", value: "NRIC" },
  { key: "Passport", value: "Passport" },
  { key: "FIN", value: "FIN" },
];

const genderData = [
  { key: "M", value: "Male" },
  { key: "F", value: "Female" },
];

export var dependantCount = 0;

export default function DependantList() {
  //FORM VALIDATATION STATUS
  const [isValid, setIsValid] = useState(false);

  //SELECTED DEPENDANT TABLE ROW
  const [selectedRow, setSelectedRow] = useState(0);

  const [depFullName, setDepFullName] = useState("");
  const [date, setDate] = useState(dayjs());
  const [rows, setRows] = useState([
    // {
    //   fullname: "Johnny English",
    //   dob: "10-3-1981",
    //   gender: "M",
    //   race: "CHI",
    //   idNumber: "1",
    //   relationship: "Son",
    //   yearsToSupport: "10",
    // },
    // {
    //   fullname: "Michael Jordan",
    //   dob: "10-3-1981",
    //   gender: "M",
    //   race: "CHI",
    //   idNumber: "1",
    //   relationship: "Son",
    //   yearsToSupport: "10",
    // },
    // {
    //   fullname: "Charles Barkley",
    //   dob: "10-3-1981",
    //   gender: "M",
    //   race: "CHI",
    //   idNumber: "1",
    //   relationship: "Son",
    //   yearsToSupport: "10",
    // },
    // {
    //   fullname: "Reggie Miller",
    //   dob: "10-3-1981",
    //   gender: "M",
    //   race: "CHI",
    //   idNumber: "1",
    //   relationship: "Son",
    //   yearsToSupport: "10",
    // },
  ]);

  const [depGender, setDepGender] = useState("");
  const [depRace, setDepRace] = useState("");
  const [depIdType, setDepIdType] = useState("");
  const [depIdNumber, setDepIdNumber] = useState("");
  const [depRelationship, setDepRelationship] = useState("");
  const [depYearsToSupport, setYearsToSupport] = useState("");

  //COMPONENT ID
  let id = "";

  /**
   * 1. VALIDITE FORM USING ERROR MESSAGES
   *     "CALCULATE VALIDITY" IS SIMILAR TO "VALIDATE FORM" IT VALIDATES BY ERROR MESSAGE.
   *       WHEN ALL FIELD'S ERROR MESSAGES ARE EMPTY. (VALID = TRUE)
   *
   * 2. THIS FUNCTION IS ALSO RESPONSIBLE FOR ENABLING / DISABLING THE NEXT BUYTTON, THEREFORE IS TRIGGERED BY EACH UI EVENT
   */
  function calculateValidity() {
    if (
      depFullNameError === "" &&
      depGenderError === "" &&
      depRaceError === "" &&
      depIdTypeError === "" &&
      depIdNumberError === "" &&
      depRelationshipError === "" &&
      depYearsToSupportError === "" &&
      rows.length < 5
    ) {
      console.log(rows.length);

      setIsValid(true);
    } else {
      console.log("depFullNameError = " + depFullNameError);
      console.log("depGenderError = " + depGenderError);
      console.log("depRaceError = " + depRaceError);
      console.log("depIdTypeError = " + depIdTypeError);
      console.log("depIdNumberError = " + depIdNumberError);
      console.log("depRelationshipError = " + depRelationshipError);
      console.log("depYearsToSupportError = " + depYearsToSupportError);

      setIsValid(false);
    }
  }

  function handleChange(e, object) {
    if (e instanceof PointerEvent) {
      //DROPDOWNS
      id = object.props.id.toLowerCase();

      if (id === "depgender") {
        setDepGender(e.target.value);
        depGenderError = "";
      }

      if (id === "deprace") {
        setDepRace(e.target.value);
        depRaceError = "";
      }

      if (id === "depidtype") {
        setDepIdType(e.target.value);
        depIdTypeError = "";
      }
    } else {
      id = e.target.id;

      //TEXTFIELDS
      //FULLNAME
      if (id === "depFullName" && alphanum.test(e.target.value)) {
        if (e.target.value.length === 0) {
          depFullNameError = "Full name is required.";
        } else if (e.target.value.length > 70) {
          depFullNameError = "Full name exceeded 70 characters";
        } else {
          depFullNameError = "";
        }

        setDepFullName(e.target.value);
      }

      //ID NUMBER
      if (id === "depIdNumber" && alphanum.test(e.target.value)) {
        if (e.target.value.length === 0) depIdNumberError = "Identity number is required.";
        else if (e.target.value.length > 12) depIdNumberError = "Identity number is more than 30 charracterss.";
        else depIdNumberError = "";

        setDepIdNumber(e.target.value);
      }

      //RELATIONSHIP
      if (id === "depRelationship" && alphanum.test(e.target.value)) {
        if (e.target.value.length === 0) depRelationshipError = "Relationship description is required";
        else if (e.target.value.length > 30) depRelationshipError = "Relationship description exceeded 30 characters";
        else depRelationshipError = "";

        setDepRelationship(e.target.value);
      }

      //YEARS TO SUPPORT
      if (id === "depYearsToSupport" && reNumbers.test(e.target.value)) {
        if (e.target.value.length === 0) depYearsToSupportError = "Years to support is required.";
        else if (e.target.value.length > 2) depYearsToSupportError = "Years to support is more than 2 characters.";
        else depYearsToSupportError = "";

        setYearsToSupport(e.target.value);
      }
    }

    calculateValidity();
  }

  function addDependant(e) {
    //Add Dependant
    // const newDependant = { fullname: "Charles Barkley" };
    // const newRows = [...rows, { fullname: "Charles Barkley" }];
    var dependant = {
      fullname: depFullName,
      dob: date.$D + "-" + date.$M + "-" + date.$y,
      gender: depGender,
      race: depRace,
      idType: depIdType,
      idNumber: depIdNumber,
      relationship: depRelationship,
      yearsToSupport: depYearsToSupport,
    };

    const newRows = [...rows, dependant];
    dependantCount = newRows.length;
    setRows(newRows);
    dependant = {};

    setDepFullName("");
    // setDate("");
    setDepGender("");
    setDepRace("");
    setDepIdType("");
    setDepIdNumber("");
    setDepRelationship("");
    setYearsToSupport("");
  }

  function removeDependant(rows, index) {
    //Remove dependant
    rows.splice(index, 1);
    dependantCount = rows.length;
    setRows(rows);
  }

  const handleSelectRow = (rowIndex, row) => {
    setSelectedRow(rowIndex);
  };

  return (
    <>
      {/*FULLNAME*/}
      <GridTextfield
        id="depFullName"
        key="depFullName"
        columnSize="6"
        label="Full Name (As per NRIC/Passport)"
        currState={depFullName}
        onChange={handleChange}
        error={depFullNameError}
        helperText={depFullNameError}
      />
      {/* DATE OF BIRTH */}
      <Grid size={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD MMM YYYY"
            label="Data of Birth"
            value={date}
            onChange={(newDate) => setDate(newDate)}
          />
        </LocalizationProvider>
      </Grid>

      {/* GENDER */}
      <GridDropdown
        id="depGender"
        columnSize="3"
        label="Gender"
        defaultValue=""
        currState={depGender}
        data={genderData}
        error={depGenderError}
        onChange={handleChange}
      />

      {/* RACE */}
      <GridDropdown
        id="depRace"
        columnSize="3"
        label="Race"
        defaultValue=""
        currState={depRace}
        data={raceData}
        error={depRaceError}
        onChange={handleChange}
      />

      {/* IDENTITY TYPE */}
      <GridDropdown
        id="depIdType"
        columnSize="3"
        label="Identity Type"
        defaultValue="depIdType"
        currState={depIdType}
        data={identityTypeData}
        error={depIdTypeError}
        onChange={handleChange}
      />

      {/* ID NUMBER */}
      <GridTextfield
        id="depIdNumber"
        columnSize="3"
        label="Identification Number"
        currState={depIdNumber}
        error={depIdNumberError}
        helperText={depIdNumberError}
        onChange={handleChange}
      />

      {/* RELATIONSHIP */}
      <GridTextfield
        id="depRelationship"
        columnSize="6"
        label="Relationship with client"
        currState={depRelationship}
        error={depRelationshipError}
        helperText={depRelationshipError}
        onChange={handleChange}
      />

      {/* YEARS TO SUPPORT */}
      <GridTextfield
        id="depYearsToSupport"
        columnSize="6"
        label="Years to support"
        currState={depYearsToSupport}
        error={depYearsToSupportError}
        helperText={depYearsToSupportError}
        onChange={handleChange}
      />

      {rows.length < 5 && (
        <>
          <Button disabled={!isValid} variant="contained" onClick={(e) => addDependant(e)}>
            Add Dependant
          </Button>
        </>
      )}

      {/*==============================
        DEPENDANT - TABLE LIST
        ==============================*/}
      {rows.length >= 1 && (
        <>
          <Grid size={12}>
            <TableContainer component={Paper}>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Fullname</TableCell>
                  <TableCell align="left">D.O.B</TableCell>
                  <TableCell align="left">Gender</TableCell>
                  <TableCell align="left">Race</TableCell>
                  <TableCell align="left">Id Type</TableCell>
                  <TableCell align="left">Id No</TableCell>
                  <TableCell align="left">Relationship</TableCell>
                  <TableCell align="left">Years to support</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row, index) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    selected={selectedRow === index + 1}
                    onClick={() => handleSelectRow(index + 1, row)}
                  >
                    <TableCell componen="th" sacope="row">
                      {row.fullname}
                    </TableCell>
                    <TableCell align="left">{row.dob}</TableCell>
                    <TableCell align="left">{row.gender}</TableCell>
                    <TableCell align="left">{row.race}</TableCell>
                    <TableCell align="left">{row.idType}</TableCell>
                    <TableCell align="left">{row.idNumber}</TableCell>
                    <TableCell align="left">{row.relationship}</TableCell>
                    <TableCell align="left">{row.yearsToSupport}</TableCell>
                    <TableCell align="left">
                      <Button variant="text" onClick={() => removeDependant(rows, index)} sx={{ color: "red" }}>
                        X
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </TableContainer>
          </Grid>
        </>
      )}

      {/*==============================
        DEPENDANT - REMARKS
        ==============================*/}
      {/* <Grid size={12}>
        <Typography variant="body1" gutterBottom>
          Remarks
        </Typography>

        <TextareaAutosize
          placeholder="Type here..."
          style={{ width: "100%" }}
          minRows={5}
        />
      </Grid> */}
    </>
  );
}
